import { colors, TableCell, TableRow } from '@insurancemenu/imenu-components-lib';
import styled, { css, CSSProp } from 'styled-components';
import { FamilyMemberStatus } from 'types/censusService';

interface TableRowStylings {
  $familyIndex: number;
  $isLastFamilyMember: boolean;
  $status?: FamilyMemberStatus;
}

export const TableRowStyled = styled(TableRow)<TableRowStylings>`
  border-bottom: ${(props): CSSProp => (props.$isLastFamilyMember ? `1px solid ${colors.neutral[400]}` : null)};

  ${({ $familyIndex }): CSSProp => {
    return css`
      background-color: ${$familyIndex % 2 === 0 ? colors.neutral[100] : colors.neutral.white};
    `;
  }}
`;

export const NumberTableCellStyled = styled(TableCell)<{ $status?: FamilyMemberStatus }>`
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 700;
  text-align: center;
  padding: 1.8rem 1.2rem;
  border: 0.05rem solid ${colors.neutral[300]};
  width: 1.5rem;
  position: sticky;
  left: 0;
  z-index: 1;
  box-sizing: border-box;

  ${({ $status }): CSSProp => {
    switch ($status) {
      case FamilyMemberStatus.INVALID:
        return css`
          background-color: #ffc2c5;
          color: ${colors.red[600]};

          &::after {
            position: absolute;
            content: '';
            inset: 0;
            border-left: 4px solid ${colors.red[600]};
            border-right: 2px solid ${colors.neutral[300]};
          }
        `;
      case FamilyMemberStatus.WARNING:
        return css`
          background-color: #ffdbc2;
          color: ${colors.orange[900]};

          &::after {
            position: absolute;
            content: '';
            inset: 0;
            border-left: 4px solid ${colors.orange[700]};
            border-right: 2px solid ${colors.neutral[300]};
          }
        `;
      case FamilyMemberStatus.VALID:
      default:
        return css`
          background-color: ${colors.green[200]};
          color: ${colors.green[700]};

          &::after {
            position: absolute;
            content: '';
            inset: 0;
            border-left: 4px solid ${colors.green[600]};
            border-right: 2px solid ${colors.neutral[300]};
          }
        `;
    }
  }}
`;
